if (
  typeof window._pagination == "undefined" ||
  window._pagination.pages.length <= 0
) {
  console.info("a variável _pagination não foi setada ou não há paginação");
  var _pagination = false;
}

var infiniteProducts = {
  pagination: window._pagination, // a variável _pagination é montada pelo liquid pegando as infos da paginação
  listsWrapper: $("[data-list-products-wrapper]"), // Elemento que engloba as páginas de produtos
  getCurrentPage: function () {
    // Retorna a página atual
    return this.pagination.currentPage;
  },
  getNextPage: function () {
    var _this = this;
    var currentPage = _this.getCurrentPage();
    var nextUrl = _this.pagination.nextUrl;

    // Verifica se já não há um ajax em andamento para não encadear vários requests
    if (!_this.listsWrapper.hasClass("searching")) {
      // Verifica se a página atual não é a última página
      if (currentPage >= _this.pagination.totalPages) {
        console.info("não há mais páginas");
        _this.listsWrapper.addClass("no-more-products");
        _this.listsWrapper
          .find('[data-action="load-products"]')
          .html("Não há mais produtos");
      } else {
        _this.listsWrapper.addClass("searching");

        (async () => {
          var response = await fetch(nextUrl);
          var data = await response.text();
          var parser = new DOMParser();
          var doc = parser.parseFromString(data, "text/html");
          var products = doc.querySelectorAll(
            "[data-list-products-wrapper] .list-products > *"
          );

          _this.setCurrentPage(currentPage + 1);

          // console.log(products)

          // Renderiza os produtos da página
          _this.renderMoreProducts(products);
          window.lazyLoadInstance.update();
          _this.listsWrapper.removeClass("searching");
          store.getPriceProd();
        })();
      }
    }
  },
  renderMoreProducts: function (_htmlProducts) {
    // Monta o html dos produtos da página carregada por ajax
    var _this = this;
    // var $listProducts = '<div class="list-products" data-page="' + _this.getCurrentPage() + '"></div>';
    var $listProducts = "";
    var $listProducts = $($listProducts);
    var st = $(window).scrollTop();

    console.info(st);

    $listProducts.html(_htmlProducts);

    _this.listsWrapper.find(".list-products").append(_htmlProducts);

    _this.runProductsSobrando();

    setTimeout(function () {
      $(window).scrollTop(st);
    }, 5);
  },
  setCurrentPage: function (_number) {
    var current = this.getCurrentPage();
    var nextUrl = this.pagination.nextUrl;

    // Verifica se a página atual não é maior que o total de páginas
    if (_number <= this.pagination.totalPages) {
      console.info("next url", nextUrl);

      // seta a página atual
      this.pagination.currentPage = _number;

      // Verifica se há próxima página
      if (_number < this.pagination.totalPages) {
        // Seta a url da próxima página
        nextUrl = this.pagination.pages[_number].url;
        this.pagination.nextUrl = nextUrl;
      }
    }
  },
  runProductsSobrando: function () {
    var _this = this;
    var productsInLine = 1;
    var listProducts = _this.listsWrapper.find(">*");
    var lengthProducts = listProducts.length;
    var mod;

    // Procura produtos que estão sobrando quando ainda há produtos para serem listados
    // Ex: 3 produtos em uma linha de 4

    if ($("body").width() > 768) {
      // 4 produtos por linha

      productsInLine = 3;

      if ($("body").width() < 768) {
        productsInLine = 2;
      }
    } else {
      // 2 produtos por linha
    }

    mod = lengthProducts % productsInLine;

    if (_this.pagination.currentPage < _this.pagination.totalPages) {
      if (mod > 0) {
        for (var i = 0; i < mod; i++) {
          console.info(listProducts[lengthProducts - 1 - i]);
          $(listProducts[lengthProducts - 1 - i]).addClass("produto-sobrando");
        }
      }
    }

    console.info("productsInLine", productsInLine);
    console.info("lengthProducts", lengthProducts);
  },
  init: function () {
    var _this = this;

    if (_this.pagination.totalPages > 1) {
      _this.runProductsSobrando();

      $(window).on("scroll", function (event) {
        var stTop = $(this).scrollTop();
        var stBottom = stTop + $(this).height() * 1.2;

        // Calcula o final da div de produtos para buscar mais produtos
        var listEnd =
          _this.listsWrapper.offset().top +
          (_this.listsWrapper.outerHeight(true) - 3 * window.innerHeight);

        // console.info('stBottom=', stBottom, 'listEnd=', listEnd);

        if (stBottom >= listEnd) {
          //console.info('teste');
          //console.info('cheguei no final');
          _this.getNextPage();
        }
      });
    } else {
      _this.listsWrapper.addClass("no-more-products");
      _this.listsWrapper
        .find('[data-action="load-products"]')
        .html("Não há mais produtos");
    }
  },
};

// Verifica se há paginação para inicializar o infinite scroll
if (infiniteProducts.pagination) {
  infiniteProducts.init();
}
